import {
  getData,
  postData,
  putData,
  editStatusData,
  deleteData,
  getDownloadDataExcel,
} from "../../api";

export const addWishlist = async (d) => {

  try {
    return await postData(`/wishlist`, {
      product_id: d?.product_id,
      variant_id: d?.variant_id,

    });
  } catch (error) {
    console.log(error);
  }
};

export const getWishlist = async () => {
  try {
    return await getData(`/wishlist`);
  } catch (error) {
    console.log(error);
  }
};




